import React from 'react'
import { useState } from "react";
// import { Tabs } from "antd";
import LoginForm from '../components/login/LoginForm';
import LayoutLogin from '../layouts/Login/LoginLayout';
import { useDispatch } from 'react-redux';
import useChangeLanguage from '@/hooks/useChangeLanguage';
// import { useTranslation } from 'react-i18next';
import api from '@/services/api'

const LoginPage = ({ loading }) => {

  const [email, setEmail] = useState("");

  

  const onClickForgotPasswordHandler = () => {
    
  }

  const d = useChangeLanguage()


  return (
    <div id="login-layout">
      <LayoutLogin element={
        <LoginForm onChangeEmail={(e) => setEmail(e)} />
      } />

      <div className="fixed-footer">
        <p>
          Powered by{' '}
          <span onClick={() => window.open('https://www.parts-soft.nl/', '_blank')} style={{ cursor: "pointer" }}>
            Parts-Soft
          </span>
        </p>
      </div>
      -
    </div>
  )
}

export default LoginPage

